import { MonoTypeOperatorFunction, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export const catchAndRethrow =
  <T>(handler: (error: unknown) => Observable<unknown>): MonoTypeOperatorFunction<T> =>
  obs$ =>
    obs$.pipe(catchError((error: unknown) => handler(error).pipe(switchMap(() => throwError(() => error)))));
